import {useRoute} from '@react-navigation/native';
import {
  Alert,
  Button,
  ButtonBorder,
  Div,
  HeaderBack,
  ImageView,
  InputItem,
  Label,
} from 'components';
import {Ecolors, Icons, stringApp} from 'constant';
import React, {useEffect, useState} from 'react';
import {Platform} from 'react-native';
import {ScrollView} from 'react-native-gesture-handler';
import {useSafeAreaInsets} from 'react-native-safe-area-context';
import {goBack, navigate, uploadFile} from 'services';
import {apiMain} from 'services/apis/apiMain';
import {useAppSelector} from 'store/hooks';
import {
  convertTimestamp,
  getUuid,
  heightScale,
  parseMultilanguage,
} from 'utils';
import {submitForm} from './api';

function C(p: {isHideIcon?: boolean}) {
  return (
    <Div
      widthHeight={20}
      borderRadius={20}
      alignItems={'center'}
      justifyContent={'center'}
      backgroundColor={Ecolors.mainColor}>
      {!p.isHideIcon && (
        <ImageView
          widthHeight={11}
          source={Icons.checkconfirminfo}
          tintColor={Ecolors.whiteColor}
          resizeMode={'contain'}
        />
      )}
    </Div>
  );
}
function L() {
  return (
    <Div
      width={29}
      height={1}
      backgroundColor={Ecolors.mainColor}
      marginHorizontal={4}
    />
  );
}

function Line() {
  return (
    <>
      <Div
        width={'100%'}
        alignItems={'center'}
        flexDirection={'row'}
        justifyContent={'center'}>
        <C />
        <L />
        <C />
        <L />
        <C />
        <L />
        <C isHideIcon={true} />
      </Div>
    </>
  );
}

function Lbl(p: {content: string; marginTop?: number}) {
  return <Label marginTop={p.marginTop || 0}>{p.content}</Label>;
}

function ItemII(p: {icon: any; title: string; children?: any}) {
  const [isVisible, setIsVisible] = useState<boolean>(true);

  return (
    <Div paddingHorizontal={16} paddingTop={38}>
      <Button
        borderBottomWidth={0.7}
        borderBottomColor={Ecolors.spaceColor}
        paddingBottom={9}
        onPress={() => {
          setIsVisible(a => !a);
        }}
        flexDirection={'row'}
        alignItems={'center'}
        justifyContent={'space-between'}>
        <Div
          flex={1}
          flexDirection={'row'}
          alignItems={'center'}
          justifyContent={'flex-start'}>
          <ImageView
            source={p.icon}
            tintColor={Ecolors.textColor}
            widthHeight={19}
            resizeMode={'contain'}
          />
          <Div
            flex={1}
            flexDirection={'row'}
            alignItems={'center'}
            paddingRight={5}>
            <Label marginLeft={10} fontWeight={'700'}>
              {p.title}
            </Label>
          </Div>
        </Div>
        <ImageView
          tintColor={Ecolors.textColor}
          widthHeight={14}
          source={!isVisible ? Icons.down : Icons.up}
          resizeMode={'contain'}
        />
      </Button>
      {isVisible ? p.children : <></>}
    </Div>
  );
}

const ReviewInfoCMNDModal = () => {
  const userRedux = useAppSelector(state => state.authen.currentUser);
  const I18nState = useAppSelector(state => state.languages.I18nState);
  const route = useRoute<any>();
  const [state, setState] = useState<any>({});
  const insets = useSafeAreaInsets();
  const [loading, setLoading] = useState<boolean>(false);
  const [userCountry, setUserCountry] = useState<any>({});
  const {userProfile, phone, person, email} = state;

  const userName = userProfile?.name || '';
  const dob = userProfile?.dob || '';
  const dateOfIssue = userProfile?.dateOfIssue || '';
  const frontCardImage = state?.rawImage?.front || '';
  const backCardImage = state?.rawImage?.back || '';
  const selfieImage = state?.rawImage?.selfie || '';

  useEffect(() => {
    bindData();
    return () => {};
  }, []);

  const bindData = async () => {
    setState(route.params?.data || {});
    const listCountry = await apiMain.getCountry();
    const country = listCountry.data.find(
      (a: any) => a.id == userRedux?.nationalityId,
    );
    if (!!country) {
      setUserCountry(country);
    }
  };

  const onConfirm = async base64File => {
    try {
      if (loading) {
        return;
      }
      setLoading(true);
      const photoAfter: any = await uploadFile({
        fileBase64:
          Platform.OS === 'android'
            ? backCardImage.replace(/\n/g, '')
            : backCardImage,
      });
      const photoBefore: any = await uploadFile({
        fileBase64:
          Platform.OS === 'android'
            ? frontCardImage.replace(/\n/g, '')
            : frontCardImage,
      });

      return await submitForm({
        file: base64File,
        idNo: userProfile?.idNo,
        dateOfIssue: `${dateOfIssue}`.split('/').reverse().join(''),
        expireDateOfIdNo: '',
        placeOfIssue: userProfile?.placeOfIssue,
        photoAfterURL: photoAfter?.url,
        photoBeforeURL: photoBefore?.url,
        name: userName,
        dob: `${dob}`.split('/').reverse().join(''),
      });
    } catch (error: any) {
      Alert.showError({
        multilanguage: false,
        content: error.message,
      });
    } finally {
      setLoading(false);
    }
  };

  const onPressConfirm = async () => {
    navigate('DigitalSignatureChangeCMNDScreen', {
      flowApp: 'ChangeCMNDtoCCCD',
      callback: async base64File => {
        await goBack().then(async () => {
          await onConfirm(base64File);
        });
      },
    });
  };

  return (
    <Div height={'100%'} backgroundColor={Ecolors.whiteColor}>
      <HeaderBack
        type={4}
        contentCenter={true}
        title={`changecmnd.thongtincanhan`}
      />
      <Div flex={1}>
        <ScrollView>
          <Line />
          <ItemII
            title={'reviewinfoscreen.thongtincanhan'}
            icon={Icons.profileinfo}>
            <Lbl marginTop={23} content={`reviewinfoscreen.thongtinnhadautu`} />
            <Lbl marginTop={23} content={`reviewinfoscreen.hoten`} />
            <InputItem
              marginTop={6}
              isInput={false}
              value={userName}
              marginHorizontal={0}
            />
            <Lbl marginTop={13} content={`reviewinfoscreen.gioitinh`} />
            <InputItem
              marginTop={6}
              isInput={false}
              value={
                userRedux?.gender == stringApp.gender.nam
                  ? parseMultilanguage(`accountverify.nam`)
                  : parseMultilanguage(`accountverify.nu`)
              }
              marginHorizontal={0}
            />
            <Lbl marginTop={13} content={`reviewinfoscreen.ngaysinh`} />
            <InputItem
              marginTop={6}
              isInput={false}
              value={dob}
              marginHorizontal={0}
            />
            <Lbl marginTop={13} content={`reviewinfoscreen.quoctich`} />
            <InputItem
              marginTop={6}
              isInput={false}
              value={
                I18nState == 'vi'
                  ? userCountry?.name
                  : userCountry?.nameEn || ''
              }
              marginHorizontal={0}
            />
            <Lbl marginTop={13} content={`reviewinfoscreen.email`} />
            <InputItem
              marginTop={6}
              isInput={false}
              value={email || userRedux?.email || ''}
              marginHorizontal={0}
            />
            <Lbl marginTop={13} content={`reviewinfoscreen.sodienthoai`} />
            <Div
              marginTop={6}
              flexDirection={'row'}
              alignItems={'flex-start'}
              justifyContent={'space-between'}>
              <Div width={99}>
                <InputItem
                  // inputRef={phonePostal}
                  placeholder={''}
                  isInput={false}
                  keyboardType={'name-phone-pad'}
                  marginHorizontal={0}
                  value={'+84'}
                />
              </Div>
              <Div width={198}>
                <InputItem
                  isInput={false}
                  value={phone || userRedux?.phone || ''}
                  marginHorizontal={0}
                />
              </Div>
            </Div>

            <Lbl marginTop={36} content={`reviewinfoscreen.thongtingiayto`} />
            <Label
              marginTop={4}
              size={12}
              color={Ecolors.grayColor}>{`reviewinfoscreen.note`}</Label>
            <Lbl marginTop={13} content={`reviewinfoscreen.loaigiayto`} />
            <InputItem
              marginTop={6}
              isInput={false}
              value={userProfile?.idTypeId == 1 ? 'CCCD' : ''}
              marginHorizontal={0}
            />
            <Lbl marginTop={13} content={`reviewinfoscreen.sohieugiayto`} />
            <InputItem
              marginTop={6}
              isInput={false}
              value={userProfile?.idNo || ''}
              marginHorizontal={0}
            />
            <Lbl marginTop={13} content={`reviewinfoscreen.ngaycap`} />
            <InputItem
              marginTop={6}
              isInput={false}
              value={dateOfIssue}
              marginHorizontal={0}
            />
            <Lbl marginTop={13} content={`reviewinfoscreen.noicap`} />
            <InputItem
              marginTop={6}
              isInput={false}
              value={userProfile?.placeOfIssue || ''}
              marginHorizontal={0}
            />
            {/* <Label marginTop={20} size={14}>
            {`reviewinfoscreen.taihinhanh`}
          </Label> */}
            <Div
              flexDirection={'row'}
              marginTop={6}
              alignItems={'center'}
              justifyContent={'space-between'}>
              <ImageView
                width={161}
                height={100}
                borderRadius={5}
                resizeMode={'contain'}
                source={{
                  uri: `data:image/png;base64,${frontCardImage}`,
                }}
              />
              <ImageView
                borderRadius={5}
                width={161}
                height={100}
                resizeMode={'contain'}
                source={{
                  uri: `data:image/png;base64,${backCardImage}`,
                }}
              />
            </Div>
            <Div
              flexDirection={'row'}
              marginTop={19}
              alignItems={'center'}
              justifyContent={'space-between'}>
              <ImageView
                width={110}
                height={150}
                borderRadius={5}
                resizeMode={'contain'}
                source={{
                  uri: `data:image/png;base64,${selfieImage}`,
                }}
              />
            </Div>
          </ItemII>
        </ScrollView>
      </Div>
      <Div
        width={'100%'}
        flexDirection={'row'}
        alignItems={'center'}
        style={{
          paddingBottom: insets.bottom + heightScale(20),
        }}
        paddingTop={10}
        justifyContent={'center'}>
        <ButtonBorder
          loading={loading}
          type={1}
          onPress={() => {
            onPressConfirm();
          }}
          title={`accountverify.save`}
        />
      </Div>
    </Div>
  );
};

export default React.memo(ReviewInfoCMNDModal);
